<template>
<b-container fluid>
  <h1>BOM or KIT Information</h1>
  <b-row align-h="center">
    <b-form @submit="searchBomKit" inline>
      <b-form-input placeholder="Bom/Kit Number" v-model="form.bomKitNumber" class="mx-1" />
      <b-form-input placeholder="Description" v-model="form.bomKitDescription" class="mx-1" />
      <b-form-checkbox v-model="form.showInactive" class="mx-1">Show Inactive BOMs/KITs</b-form-checkbox>
      <b-btn variant="primary" type="submit" class="mx-1">Search BOMs/KITs</b-btn>
    </b-form>
  </b-row>
  <b-alert show v-if="alert.message != ''" :variant="alert.variant" class="mt-2">{{alert.message}}</b-alert>
  <section v-if="items.length > 0" class="mx-2">
    <b-row class="mt-2">
      <b-col cols=8>
        <b-form-input v-model="filter" placeholder="Type to Search" />
      </b-col>
      <b-col>
        <b-pagination
          :current-page="currentPage" :per-page="perPage"
          :total-rows="totalRows" v-model="currentPage"
          align="right" class="mb-0"
        />
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-table
        :items="items" :fields="fields" class="my-0" stacked="md"
        :busy="busy" :current-page="currentPage" :per-page="perPage"
        :filter="filter" @filtered="onFilter"
      >
      <template slot='bomnum' slot-scope='data'>
        <div v-if="data.item.parttype == 'BOM'">{{data.item.bomnum}}</div>
        <div v-else>N/A</div>
      </template>
      <template slot='active' slot-scope='data'>
        {{ data.item.active ? '✅' : '❌' }}
      </template>
      <template slot='actions' slot-scope='data'>
        <b-btn class="btn-toggler" size="sm" @click="data.toggleDetails">{{ data.detailsShowing ? 'Hide' : 'Show'}} Details</b-btn>
      </template>
      <template slot="row-details" slot-scope='data'>
        <div v-if="data.item.parttype == 'KIT'">
          <KitInfo :item="data.item" :alert="alert" />
        </div>
        <div v-else-if="data.item.parttype == 'BOM' || data.item.parttype == 'I-BOM'">
          <BomInfo :item="data.item" :alert="alert" />
        </div>
        <div v-else-if="data.item.parttype == 'I-IND'">
          I-IND - could not find a default BOM ever assigned, please check fishbowl
        </div>
        <div v-else>
          Seems we buy this part as it does not have a Default BOM set and is not a KIT.
        </div>
      </template>
      </b-table>
    </b-row>
  </section>
  <b-modal ref="loadingModalRef" centered hide-header hide-footer>
    <div>
      <center>
        <p>Loading Results, please wait</p>
        <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" lass="my-3" />
      </center>
    </div>
  </b-modal>
</b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
import BomInfo from './BomInfo';
import KitInfo from './KitInfo';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner,
    NiceDate,
    BomInfo,
    KitInfo,
  },
  data() {
    return {
      alert: {
        variant: 'danger',
        message: '',
      },
      form: {
        bomKitNumber: this.$route.query.bomKitNumber,
        bomKitDescription: this.$route.query.bomKitDescription,
        showInactive: this.$route.query.showInactive
      },
      busy: false,
      fields: [
        { key: 'partnum', label: 'Part Number', sortable: true },
        { key: 'partdescription', label: 'Part Description', sortable: true },
        { key: 'bomnum', label: 'BOM Number', sortable: true },
        { key: 'locations', label: 'Location', sortable: true },
        { key: 'productnum', label: 'Product Number', sortable: true },
        { key: 'productdescription', label: 'Product Description', sortable: true },
        { key: 'parttype', label: 'Part Type', sortable: true },
        { key: 'active', label: 'Active', sortable: true},
        'actions',
      ],
      items: [],
      filter: '',
      perPage: 15,
      currentPage: 1,
      totalRows: 0,
    }
  },
  mounted() {
    if (this.form.bomKitNumber || this.form.bomKitDescription) {
      this.searchBomKit();
    }
  },
  methods: {
    searchBomKit(evt) {

      if (evt) evt.preventDefault();
      this.$refs.loadingModalRef.show();
      this.alert.message = '';
      this.$router.push({ name: 'BOM KIT Info', query: this.form });

      this.busy = true;
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/bom-kit/search`,
        data: this.form,
      }).then((response) => {
        this.items = response.data;
        this.totalRows = this.items.length;
        if (this.totalRows == 0) {
          this.alert.variant = 'warning';
          this.alert.message = 'No BOMs/KITs Found';
        }
        if(this.totalRows == 1) {
          setTimeout( () => { document.querySelector('.btn-toggler').click() }, 1000)
        }
        this.busy = false;
        this.$refs.loadingModalRef.hide();
      }).catch((error) => {
        this.alert.variant = 'danger';
        this.alert.message = 'Search Failed. See console for more information';
        console.error(error);
        this.$refs.loadingModalRef.hide();
      });
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    }
  },
}
</script>

<style>
.b-table th {
  background: #007bff;
  color: #fff;
}
.b-table tr {
  background-color: rgba(90, 90, 90, 0.1);
}
.b-table .b-table-details th {
  background: inherit;
  color: inherit;
}
.b-table-details {
  border: 2px;
  border-style: dotted none solid none;
  background-color: inherit !important;
}
.b-table .b-table-details tr {
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/BomKit.vue